import { CardQueryPage } from './card/cardquery';
import { BooksOverview } from './books/overview/mybooks';
import { BooksList } from './books/bookslist/bookslist';

export const LIFE_INDEX = [
  CardQueryPage,
  BooksOverview,
  BooksList,
]


// WEBPACK FOOTER //
// ./src/pages/application/life/index.ts